import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(() => ({
  headTitle: {
    marginBottom: '41px',
    height: '19px',
    fontSize: '21.97px',
    letterSpacing: '0.25px',
    lineHeight: '27px',
    color: 'rgba(0,0,0,0.87)',
  },
  boldHeader: {
    marginBottom: '15px',
    height: '19px',
    width: '242px',
    fontSize: '16.97px',
    letterSpacing: '0.25px',
    lineHeight: '27px',
    color: 'rgba(0,0,0,0.87)',
    fontWeight: 'bold',
  },
  subTitle: {
    marginBottom: '25px',
    height: '15px',
    fontSize: '13.78px',
    letterSpacing: '0.25px',
    lineHeight: '27px',
    color: 'rgba(0,0,0,0.6)',
  },
}));

export const BoldTitle = ({ title, text }) => {
  const classes = useStyle();
  return (
    <div className={classes.boldHeader}>
      {<FormattedMessage id={title} />}&nbsp;{text}
    </div>
  );
};

BoldTitle.propTypes = {
  title: PropTypes.any,
  text: PropTypes.any,
};

export const HeadTitle = ({ title }) => {
  const classes = useStyle();
  return <div className={classes.headTitle}>{<FormattedMessage id={title} />}</div>;
};

HeadTitle.propTypes = {
  title: PropTypes.any,
};

export const Title = ({ title }) => {
  const classes = useStyle();
  return <div className={classes.headTitle}>{title}</div>;
};

Title.propTypes = {
  title: PropTypes.any,
};

export const SubTitle = ({ title }) => {
  const classes = useStyle();
  return <div className={classes.subTitle}>{<FormattedMessage id={title} />}</div>;
};

SubTitle.propTypes = {
  title: PropTypes.any,
};
